
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.global-main-navigation{
  border-top:2px solid var(--brand-blue-300);
  margin-top:var(--spacing-8);
}

  @media (min-width: 1280px){.global-main-navigation{
    border-top:0;
    margin-top:var(--spacing-12)
}
  }

> ul{
  display:flex;
  flex-direction:column;
  list-style-type:none;
  padding:0;
}

@media (min-width: 1280px){

> ul{
    flex-direction:row
}
  }

> ul li::marker{
    display:none;
    width:0;
    height:0;
  }
`;